'use client';

import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  RadioGroup,
  RadioGroupItem,
} from '@unreserved/ui/components/radio-group';
import { Label } from '@unreserved/ui/components/label';
import { AdminDialogWrapper } from './admin-dialog-wrapper';

export interface SelectionOption {
  id: string;
  label: string;
}

export interface RadioSelectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  options: SelectionOption[];
  currentValue: string;
  onConfirm: (selectedValue: string) => void;
  onCancel?: () => void;
}

export function RadioSelectionDialog({
  open,
  onOpenChange,
  title,
  options,
  currentValue,
  onConfirm,
  onCancel,
}: RadioSelectionDialogProps) {
  const [selectedValue, setSelectedValue] = useState<string>(currentValue);

  useEffect(() => {
    if (open) {
      setSelectedValue(currentValue);
    }
  }, [open, currentValue]);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm(selectedValue);
    onOpenChange(false);
  };

  return (
    <AdminDialogWrapper
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      contentPadding={false}
      footer={{
        onCancel: handleCancel,
        onConfirm: handleConfirm,
      }}
    >
      <RadioGroup
        value={selectedValue}
        onValueChange={setSelectedValue}
        className="flex flex-col gap-4"
      >
        {options?.map((option) => (
          <div key={option?.id} className="flex items-center gap-2">
            <RadioGroupItem
              value={option?.id}
              id={option?.id}
              className="!h-5 !w-5 !size-5 !rounded-full !aspect-square !bg-white !border-2 !border-border-400 data-[state=checked]:!border-primary-600 data-[state=checked]:!bg-white cursor-pointer shrink-0 [&>span>svg]:!fill-primary-600 [&>span>svg]:!size-3.5"
            />
            <Label
              htmlFor={option?.id}
              className={`text-sm font-normal cursor-pointer leading-[21px] ${
                selectedValue === option?.id
                  ? 'text-typography-900'
                  : 'text-typography-600'
              }`}
            >
              {option?.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </AdminDialogWrapper>
  );
}
